import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { EventLogService } from '../core/services/event.log.service';
import { EventType, EVENTTYPES } from '../core/models/eventtype';
import * as moment from 'moment';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { EventLogStateService } from 'app/event-log/core/services/event-log.state.service';
import { DeleteConfirmationComponent } from '../../shared/components/delete-confirmation/delete-confirmation.component';
import { BzgModalService } from 'bz-genome-angular';
import { DateUtil } from "../../core/utils/DateUtil";


@Component({
  selector: 'eventlogdetail',
  templateUrl: 'event.log.detail.component.html',
  styleUrls: ['event.log.detail.component.scss', '../../shared/components/date-filter/date-filter.component.scss'],
  providers: [
    EventLogService
  ]
})
export class EventLogDetailComponent implements OnInit {

  eventTypes: EventType[] = EVENTTYPES;
  events: BAEventEntry[];
  selectedType: EventType;
  errorMessage: string;
  dateMin: Date = new Date();
  dateMax: Date = new Date();
  state = { dateMin: new Date(), dateMax: new Date() };
  datenNoFilterMin: Date;
  dateNoFilterMax: Date;
  separator: string;
  filtered = false;
  eventLogFilter: IEventLogFilter;
  continuationToken: string;
  hasMoreResults: boolean;
  level = 'Error';
  selectAll: boolean = false;
  showLoading = false;
  loadingMessage = '';
  downloadingFile: boolean;
  textButtonExport = 'EVENTS_LOG.EXPORT_CSV';
  @ViewChild('dpTo', { static: false }) dpTo: ElementRef;
  @ViewChild('dpFrom', { static: false }) dpFrom: ElementRef;
  @ViewChild('confirmDialog', { static: false }) confirmDialog: ConfirmDialogComponent;


  constructor(private _eventLogService: EventLogService,
    private ref: ChangeDetectorRef,
    private _modalService: BzgModalService,
    private _eventLogStateService: EventLogStateService) {
    this.dateNoFilterMax = new Date(moment().format('YYYY/MM/DD'));
    // convoluted way of get the prior day in js, the other obvious one date.now()-24*3600*1000
    // has a nasty bug in safari and iOS.
    this.datenNoFilterMin = new Date(moment().subtract(1, 'days').format('YYYY/MM/DD'));
    this.state = _eventLogStateService.getState();
    this.getStringSeparator();
    this.initializeEventLogFilter();
    this.getEventLogDetails();
  }

  ngAfterViewInit() {
    this.ref.detectChanges();
  }

  ngOnInit() { }

  private setTextDownloadButton(download: boolean) {
    if (download) {
      this.textButtonExport = 'EVENTS_LOG.DOWNLOADING';
      this.downloadingFile = true;
    } else {
      this.textButtonExport = 'EVENTS_LOG.EXPORT_CSV';
      this.downloadingFile = false;
    }
  }

  private getStringSeparator() {
    const self = this;
    this._eventLogService.getDefaultSeparatorForCSS()
      .subscribe(
        result => {
          self.separator = result;
        }, error => {
          self.separator = ',';
        });
  }

  private checkDateTimeFiltersBeforeSending() {
    if (this.dateMax.toString() === '' && this.dateMin.toString() === '') {
      this.dateMax = new Date(Date.now());
      // convoluted way of get the prior day in js, the other obvious one date.now()-24*3600*1000
      // has a nasty bug in safari and iOS.
      this.dateMin = new Date(new Date().setDate(new Date().getDate() - 1));
    }
    else if (this.dateMax.toString() === '' && this.dateMin.toString() !== '') {
      this.dateMax = new Date(Date.now());
    }
    else if (this.dateMax.toString() !== '' && this.dateMin.toString() === '') {
      this.dateMin = new Date(new Date().setDate(new Date().getDate() - 1));
    }
  }

  public set dateTimeLocalMax(date: string) {
    const actualParsedDate = date ? new Date(date) : new Date();
    const normalizedParsedDate = new Date(actualParsedDate.getTime() + (actualParsedDate.getTimezoneOffset() * 60000));
    this.dateMax = actualParsedDate;
  }

  public get dateTimeLocalMax(): string {
    return this.parseDateToStringWithFormat(this.dateMax);
  }

  public set dateTimeLocalMin(date: string) {
    const actualParsedDate = date ? new Date(date) : new Date();
    const normalizedParsedDate = new Date(actualParsedDate.getTime() + (actualParsedDate.getTimezoneOffset() * 60000));
    this.dateMin = actualParsedDate;
  }

  public get dateTimeLocalMin(): string {
    return this.parseDateToStringWithFormat(this.dateMin);
  }

  public changeEventDelete(index, value) {
    this.events = [...this.events.slice(0, index),
    { ...this.events[index], Delete: !value },
    ...this.events.slice(index + 1),]
  }

  public changeEventSelected(index, value) {
    this.events = [...this.events.slice(0, index),
    { ...this.events[index], Selected: !value },
    ...this.events.slice(index + 1),]
  }

  public parseDateMin() {
    return this.parseDateToStringWithFormat(this.dateMin);
  }

  public parseDateMax() {
    return this.parseDateToStringWithFormat(this.dateMax);
  }

  private parseDateToStringWithFormat(date: Date): string {
    let result: string;
    let dd = date.getDate().toString();
    let mm = (date.getMonth() + 1).toString();
    let hh = date.getHours().toString();
    let min = date.getMinutes().toString();
    dd = dd.length === 2 ? dd : '0' + dd;
    mm = mm.length === 2 ? mm : '0' + mm;
    hh = hh.length === 2 ? hh : '0' + hh;
    min = min.length === 2 ? min : '0' + min;
    result = [date.getFullYear(), '-', mm, '-', dd, 'T', hh, ':', min].join('');

    return result;
  }

  public tooglefiltered() {
    this.filtered = !this.filtered;
  }

  refresh() {
    this.events = [];
    this.eventLogFilter.startDate = this.state.dateMin;
    this.eventLogFilter.endDate = this.state.dateMax;
    this.eventLogFilter.level = this.level;
    this.eventLogFilter.filter.filterElements = null;
    this.continuationToken = '';
    this.hasMoreResults = false;
    this.getEventLogDetails();
  }

  downloadFile() {
    if (this.downloadingFile || !this.events || this.events.length === 0) {
      return;
    }
    this.setTextDownloadButton(true);
    this.eventLogFilter.level = this.level;
    this.loadingMessage = 'EVENTS_LOG.DOWNLOADING';
    let eventsToDownload: BAEventEntry[] = this.events.filter(event => event.Selected === true);
    this.eventLogFilter.filter.filterElements = eventsToDownload.map(event => event.RowKey);
    this._eventLogService.downloadEventLog(this.eventLogFilter)
      .subscribe(() => {
        this.showLoading = false;
        this.setTextDownloadButton(false);
      });
  }

  public filterEventLogs(dateFilter: any) {
    this.events = [];
    // Update state
    this.state = {
      dateMin: dateFilter.start,
      dateMax: dateFilter.end
    }
    this._eventLogStateService.setState(this.state);
    this.eventLogFilter.startDate = dateFilter.start;
    this.eventLogFilter.endDate = dateFilter.end;
    this.eventLogFilter.level = this.level;
    this.eventLogFilter.filter.filterElements = null;
    this.continuationToken = '';
    this.hasMoreResults = false;
    this.getEventLogDetails();
  }

  private getEventLogDetails() {
    this.selectAll = false;
    // this.selectAllEventLogs();
    this.showLoading = true;
    this.eventLogFilter.startDate = DateUtil.setFirstHourDay(this.state.dateMin);
    this.eventLogFilter.endDate = DateUtil.setLastHourDay(this.state.dateMax);
    this.eventLogFilter.level = this.level;
    this.eventLogFilter.filter.continuationToken = this.continuationToken;
    this.eventLogFilter.filter.filterElements = null;
    this._eventLogService.getEventLogDetail(this.eventLogFilter)
      .subscribe((entries: IFilterResult) => {
        this.hasMoreResults = entries.HasMoreResults;
        this.continuationToken = entries.ContinuationToken;

        const tempEventLogs = entries.Results.map((entry: BAEventEntry) => {
          return { ...entry, Delete: false, Seletected: false };
        });

        if (this.events) {
          this.events.push.apply(this.events, tempEventLogs);
        }
        else {
          this.events = tempEventLogs;
        }


      }, error => {
        this.errorMessage = error;
      },
        () => {
          this.showLoading = false;
        });
  }

  private initializeEventLogFilter() {
    this.level = 'All';
    this.eventLogFilter = {
      filter: {
        pageSize: 20,
        continuationToken: '',
        sort: 'Asc'
      } as IFilterProperties,
      level: 'All',
      startDate: this.state.dateMin,
      endDate: this.state.dateMax,
    }
  }

  public selectAllEventLogs() {
    if (this.events) {
      this.selectAll = !this.selectAll;
      this.events.forEach(e => e.Selected = this.selectAll);
    }
  }

  public selectAllEventLogsDelete() {
    if (this.events) {
      this.selectAll = !this.selectAll;
      this.events.forEach(e => e.Delete = this.selectAll);
    }
  }

  public numEventsToSelected() {
    const filesToSelected = this.events ? this.events.filter((e) => e.Selected === true) : [];
    return filesToSelected.length;
  }

  public numEventsToDelete() {
    const filesToDelete = this.events ? this.events.filter((e) => e.Delete === true) : [];
    return filesToDelete.length;
  }

  public showConfirmDialog() {
    const deleteModal = this._modalService.open(DeleteConfirmationComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: {
        title: 'EVENTS_LOG.DELETE_EVENTS_LOGS',
        message: 'EVENTS_LOG.DELETE_EVENTS_LOGS_WARNING'
      }
    });
    deleteModal.afterClosed().subscribe((result: string) => {
      if (result === 'delete') {
        this.removeAllEventLogs();
      }
    })
  }

  public removeAllEventLogs() {
    this.showLoading = true;
    this.loadingMessage = 'EVENTS_LOG.REMOVING_EVENTS_LOGS'
    const eventsToDelete = this.events.filter((e) => e.Delete === true);
    const object = eventsToDelete.map((e) => ({ partitionKey: e.PartitionKey, rowKey: e.RowKey }));
    this._eventLogService.removeEventLogs({ items: object }).subscribe(() => {
      this.showLoading = false;
      this.events = [];
      this.continuationToken = '';
      this.hasMoreResults = false;
      this.getEventLogDetails();
    });
  }

  public isTextOverflow(target) {
    let result = true;
    setTimeout(() => {
      const $element = $(target);
      const $c = $element
        .clone()
        .css({ display: 'inline', width: 'auto', visibility: 'hidden' })
        .appendTo('body');

      if ($c.width() > $element.width()) {
        result = false;
      } else {
        result = true;
      }
    }, 0);

    return result;
  }

  /**
   * validate if the download file button has to be disable or enable
   */
  public downloadButtonIsDisable() {
    return this.downloadingFile || (this.events ? this.events.length === 0 : false) || this.showLoading;
  }
}
